import React from 'react';
import { Heart } from 'lucide-react';
export function Divider() {
  return <div className="flex items-center justify-center py-4 opacity-40" data-id="element-37">
      <div className="h-px w-24 bg-brand-light/30" data-id="element-38"></div>
      <Heart className="mx-4 w-4 h-4 text-brand-accent fill-brand-accent/20" data-id="element-39" />
      <div className="h-px w-24 bg-brand-light/30" data-id="element-40"></div>
    </div>;
}